exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".jumbotron {\r\n    background-color:#2E2D88;\r\n    color: white;\r\n}\r\n\r\n.tab-content {\r\n    border-left: 1px solid #ddd;\r\n    border-right: 1px solid #ddd;\r\n    border-bottom: 1px solid #ddd;\r\n    padding: 10px;\r\n}\r\n\r\n.nav-tabs {\r\n    margin-bottom: 0;\r\n}\r\n\r\n.search-bar {\r\n    position:relative;\r\n    left:15px;\r\n    margin-top:-45px;\r\n}\r\n\r\n.member-panel {\r\n    padding:10px;\r\n}\r\n\r\n.cc-search-btn {\r\n    margin-top: 21px;\r\n    float: right;\r\n}\r\n\r\n@media screen and (max-width: 1024px) {\r\n    .cc-search-btn{\r\n        margin-left: -20px;\r\n    }\r\n}\r\n\r\n@media screen and (max-width: 786px) {\r\n    .cc-search-btn{\r\n        padding: 6px;\r\n        margin-left: -23px;\r\n    }\r\n}\r\n\r\n@media screen and (max-width: 414px) {\r\n    .cc-search-btn {\r\n        float: right;\r\n    }\r\n}\r\n\r\n.spacer {\r\n    margin-bottom: 10px;\r\n}\r\n\r\n.form-check-label {\r\n    margin-top:20px;\r\n}\r\n\r\n.delete-member-header {\r\n    background-color: #f44336 !important;\r\n    color: white;\r\n    opacity: 0.83;\r\n  }", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// c:/Projects/CCLibrary/Client/src/app/search/search.component.css
// module id = ../../../../../src/app/search/search.component.css
// module chunks = 1